import { Divider, SimpleGrid, Stack, Text } from "@mantine/core";
import { Brand, Collab, User, UserType } from "../../../../gql/__generated__/graphql";
import CollabCard from "./CollabsCard/CollabsCard";

interface CollabsListProps {
  collabs: Collab[];
  role: UserType;
  onReview: (entity: User | Brand) => void;
}

function CollabsList(props: CollabsListProps) {
  const handleMessage = (collabId: string) => {
    console.log("Message for collab:", collabId);
    // Implement messaging logic
  };

  const sortedCollabs = [...props.collabs].sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  );

  // Partition collabs into "action required" and "awaiting response"
  const { actionRequiredCollabs, awaitingResponseCollabs } =
    sortedCollabs.reduce(
      (acc, collab) => {
        const isActionRequired =
          (props.role === "BRAND_USER" &&
            (collab.actionRequiredBy === "BRAND_USER" ||
              collab.status === "AWAITING_FUNDING")) ||
          (props.role === "CREATOR" &&
            collab.actionRequiredBy === "CREATOR");

        if (isActionRequired) {
          acc.actionRequiredCollabs.push(collab);
        } else {
          acc.awaitingResponseCollabs.push(collab);
        }
        return acc;
      },
      {
        actionRequiredCollabs: [] as Collab[],
        awaitingResponseCollabs: [] as Collab[],
      }
    );

  if (props.collabs.length === 0) {
    return (
      <Text ta="center" c="dimmed" py="xl">
        No collabs found
      </Text>
    );
  }

  return (
    <Stack gap="md" data-component="CollabsList">
      {actionRequiredCollabs.length > 0 && (
        <>
          <Text fw={500} size="lg">
            Action Required ({actionRequiredCollabs.length})
          </Text>
          <SimpleGrid
            cols={{ base: 1, sm: 2, md: 3 }}
            spacing="md"
            verticalSpacing="md"
          >
            {actionRequiredCollabs.map((collab) => (
              <CollabCard
                key={collab.id}
                collab={collab}
                userRole={props.role}
                onReview={props.onReview}
              />
            ))}
          </SimpleGrid>
          {awaitingResponseCollabs.length > 0 && <Divider my="md" />}
        </>
      )}

      {awaitingResponseCollabs.length > 0 && (
        <>
          <Text fw={500} size="lg">
            Awaiting Response ({awaitingResponseCollabs.length})
          </Text>
          <SimpleGrid
            cols={{ base: 1, sm: 2, md: 3 }}
            spacing="md"
            verticalSpacing="md"
          >
            {awaitingResponseCollabs.map((collab) => (
              <CollabCard
                key={collab.id}
                collab={collab}
                userRole={props.role}
                onReview={props.onReview}
              />
            ))}
          </SimpleGrid>
        </>
      )}
    </Stack>
  );
}

export default CollabsList;
